// extracted by mini-css-extract-plugin
export default {"navbutton":"navbar_navbutton__KjaMk","nav":"navbar_nav__e5uAS","icon":"navbar_icon__W8lkn","icon2":"navbar_icon2__7jT6I","button":"navbar_button__430s4"};